/**
 * Editor toolbar presets for the email composers.
 *
 * These emails ship as real HTML, so they keep the typography controls the
 * legacy `FormEditor` enabled via `enableFontSize` / `enableFontFamily`.
 * Surfaces whose toolbar genuinely differs declare their own instead.
 */
export const EMAIL_TOOLBAR = {
  image: true,
  attachment: true,
  fontSize: true,
  fontFamily: true,
} as const;

/** Same, for surfaces whose payload has nowhere to put an attachment. */
export const EMAIL_TOOLBAR_NO_ATTACHMENTS = {
  ...EMAIL_TOOLBAR,
  attachment: false,
} as const;
